import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { tabsContent } from './content.vanilla.mjs';

const TabsContent = forwardRef(
  ({ className: classNameFromProps, ...props }, forwardedRef) => {
    const className = classNames(tabsContent, classNameFromProps);
    return /* @__PURE__ */ jsx(
      StyledTabsContent,
      {
        "data-scope": "tabs",
        "data-part": "content",
        className,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
const StyledTabsContent = styled(TabsPrimitive.Content);
TabsContent.displayName = "Tabs.Content";
TabsContent.toString = () => '[data-scope="tabs"][data-part="content"]';

export { TabsContent };
//# sourceMappingURL=Content.mjs.map
